import React, { ReactElement } from 'react';
import { useParams } from 'react-router-dom';

import { Dropdown } from 'ui/patterns';
import { Button } from 'ui/components';

import { useDeleteCustomRecords } from 'hooks';

import * as Icon from 'assets/icons';

import { confirmAlert } from 'utils/confirm-alert';
import { showSuccessToast, showErrorToast } from 'utils/showToast';

import { ErrorModal } from 'types/modalTypes';
import { TableCustomRecordOptionTypes } from './customRecordsTypes';

export default function TableOptionsHeader(
  props: TableCustomRecordOptionTypes,
): ReactElement {
  const params = useParams<{
    accountId: string;
  }>();
  const accountId = parseInt(params.accountId);
  const { mutate: deleteCustomRecords } = useDeleteCustomRecords();

  const customRecordOptions = [
    {
      value: 'Edit Record',
      icon: <Icon.Edit title="Options" />,
      groupEnd: true,
      action: () =>
        props.onRecordEditPress && props.onRecordEditPress(props.row),
    },
    {
      value: 'Delete Record',
      icon: <Icon.Delete title="Options" />,
      action: () => handleDeleteTable(),
    },
  ];

  const handleDeleteTable = () => {
    confirmAlert({
      message: 'Are you sure you want to delete this record?',
      buttons: [
        {
          label: 'Yes',
          onClick: () => {
            deleteCustomRecords(
              {
                accountId,
                lookupId: props.masterTableId,
                recordId: props.row.original._id,
              },
              {
                onSuccess: () => {
                  showSuccessToast({
                    message: 'Record deleted successfully.',
                  });
                },
                onError: (error: ErrorModal) => {
                  //if limited access true, and associated with any user in cp will throw this error with no action.
                  if (
                    (error.StatusCode === 400 || error.StatusCode === 409) &&
                    error.Errors[0].FieldName === 'CustomLookup_LimitedAccess'
                  ) {
                    confirmAlert({
                      message: `${error.Errors[0].Message}`,
                      buttons: [
                        {
                          label: 'Ok',
                          onClick: () => {},
                          className: 'pr-btn-primary',
                        },
                      ],
                    });
                  } else if (
                    error.StatusCode === 400 ||
                    error.StatusCode === 409
                  ) {
                    confirmAlert({
                      message: `${error.Errors[0].Message} Are you sure you want to delete this record?`,
                      buttons: [
                        {
                          label: 'Yes',
                          onClick: () => {
                            deleteCustomRecords(
                              {
                                accountId,
                                lookupId: props.masterTableId,
                                recordId: props.row.original._id,
                                RemoveIfAssociationWithDeletedQuestion: true,
                              },
                              {
                                onSuccess: () => {
                                  showSuccessToast({
                                    message: 'Record deleted successfully.',
                                  });
                                },
                                onError: (error: ErrorModal) => {
                                  showErrorToast({
                                    message: error.Errors[0].Message,
                                  });
                                },
                              },
                            );
                          },
                          className: 'pr-btn-primary',
                        },
                        {
                          label: 'No',
                          onClick: () => {
                            //
                          },
                        },
                      ],
                    });
                  } else {
                    showErrorToast({
                      message: error.Errors[0].Message,
                    });
                  }
                },
              },
            );
          },
          className: 'pr-btn-primary',
        },
        {
          label: 'No',
          onClick: () => {
            //
          },
        },
      ],
    });
  };

  const customTableDropdown = () => (
    <Button size="sm">
      <Icon.DotsVertical title="Options" />
    </Button>
  );

  return (
    <>
      <Dropdown
        trigger={customTableDropdown()}
        menuList={customRecordOptions}
        position="left-top"
        className="dd-listitem-options"
      />
    </>
  );
}
